import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../config/axios";
import { logger } from "../utils/logger";

// Tipos para las mutaciones
export interface LoginData {
  email: string;
  password: string;
}

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

export interface LoginResponse {
  access_token: string;
  usuario: {
    id: number;
    email: string;
    nombre: string;
    apellido: string;
    rol: string;
    requiere_cambio_password?: boolean;
  };
  requiere_cambio_password?: boolean;
}

// Función para login
const login = async (data: LoginData): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>("/login", data);
  return response.data;
};

// Función para cambiar contraseña
const changePassword = async (data: ChangePasswordData): Promise<void> => {
  await api.post("/cambiar-password", data);
};

// Hook para login
export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      // Limpiar cache de usuario actual si existe
      queryClient.setQueryData(["current-user"], data.usuario);

      // Invalidar queries que dependen del usuario autenticado
      queryClient.invalidateQueries({ queryKey: ["users"] });
      queryClient.invalidateQueries({ queryKey: ["users-emails"] });
    },
    onError: (error) => {
      logger.errorWithContext("Error en login", error);
    },
  });
};

// Hook para cambiar contraseña
export const useChangePassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      // Invalidar queries relacionadas con el usuario actual
      queryClient.invalidateQueries({ queryKey: ["current-user"] });
    },
    onError: (error) => {
      logger.errorWithContext("Error al cambiar contraseña", error);
    },
  });
};
